import { Phone } from "lucide-react";
import { trackEvent } from "@/lib/analytics";

const LINES = [
  { label: "Call (972) 712-1515", tel: "+19727121515", cls: "btn-primary", id: "local" },
  { label: "Call Toll-Free (888) 517-4575", tel: "+18885174575", cls: "btn-gold", id: "tollfree" },
];

// Two prominent tap-to-call buttons plus the callback promise.
export const CallButtons = ({ source, className = "", center = false }) => (
  <div className={className} data-testid={`${source}-call-buttons`}>
    <div className={`flex flex-col sm:flex-row sm:flex-wrap gap-3 ${center ? "sm:justify-center" : ""}`}>
      {LINES.map((l) => (
        <a
          key={l.id}
          href={`tel:${l.tel}`}
          onClick={() => trackEvent("phone_click", { source, number: l.tel })}
          className={`${l.cls} inline-flex items-center justify-center gap-2 min-h-[52px] !px-4 sm:!px-6 !tracking-[0.16em] text-center`}
          data-testid={`${source}-call-${l.id}`}
        >
          <Phone size={16} className="shrink-0" aria-hidden="true" />
          {l.label}
        </a>
      ))}
    </div>
    <p className={`mt-4 text-base font-semibold text-ink ${center ? "text-center" : ""}`} data-testid={`${source}-callback-note`}>
      We’ll call you back the same day or within 24 hours.
    </p>
  </div>
);
